import { formatCurrency } from '../../../../utils/formatters.util';
import { memo, useState } from 'react';
import { GoTriangleRight } from 'react-icons/go';
import classNames from 'classnames';
import { getRandomNumber } from '../../../../utils/helper.util';

const ItemPricing = ({
  choice,
  item,
  personalizationFees,
  personalizationBreakdown,
  quantity = 1,
  bundleInfo,
}) => {
  const colors = bundleInfo.bundle.memberChoiceItemIds[bundleInfo.customInfo.customizing].map((itemId) => {
    const item = bundleInfo.itemsById[itemId];
    const colorId = item.attributes.color;
    const color = bundleInfo.attributesByKey.color[colorId];
    return Object.assign({}, color, {
      item,
      isInStock: item?.inStockNow,
      isAvailable: true,
    });
  });

  const bundleItem = bundleInfo.selectedItems[bundleInfo.customInfo.customizing];
  const activeColor = colors.find((c) => c.id === bundleItem.attributes.color);

  const displayName = [choice?.displayName, activeColor?.value].filter((v) => !!v).join(', ');

  const rate = choice?.isFree || !bundleInfo?.bundle?.isInline ? 0 : item?.rate;

  return (
    <div className='tw-block'>
      <ItemPricingLine
        label={displayName}
        value={
          rate > 0 ? formatCurrency(rate * quantity) : bundleInfo?.bundle?.isInline ? 'FREE' : 'INCLUDED'
        }
        bottom={quantity > 1 && `(${formatCurrency(rate)} per unit)`}
        middle={quantity > 1 && <span>QTY: {quantity}</span>}
        quantity={quantity}
      />
      {personalizationFees > 0 && (
        <div className='tw-mt-4 tw-border-t tw-border-gray-300 tw-pt-4'>
          <ItemPricingLine
            label='Personalization Fees'
            value={formatCurrency(personalizationFees * quantity)}
            breakdown={personalizationBreakdown}
            labelClassName='tw-cursor-pointer'
            quantity={quantity}
          />
        </div>
      )}
    </div>
  );
};

const ItemPricingLine = ({
  label,
  bottom = null,
  middle = null,
  value,
  quantity,
  breakdown = [],
  labelClassName = '',
  className = '',
}) => {
  const [breakdownExpanded, setBreakdownExpanded] = useState(false);

  if (!value) return null;

  const onClick = () => {
    if (breakdown.length > 0) setBreakdownExpanded((prevState) => !prevState);
  };

  
  return (
    <>
      <div
        className={classNames(
          'tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2 tw-font-bold tw-text-brand-black',
          className
        )}>
        <div className='tw-flex tw-items-center tw-gap-1' onClick={onClick}>
          <p className={classNames('tw-mb-0 tw-text-sm tw-text-brand-black', labelClassName)}>{label}</p>
          {breakdown.length > 0 && (
            <div
              className={classNames('tw-transition-all tw-duration-200', {
                'tw-rotate-90': breakdownExpanded,
              })}>
              <GoTriangleRight size={12} className='tw-text-brand-black' />
            </div>
          )}
        </div>
        <div className='tw-flex tw-items-center tw-gap-2'>
          {middle && <div className='tw-text-gray-dark'>{middle}</div>}
          <p className='tw-mb-0 tw-text-sm tw-text-brand-black'>{value}</p>
        </div>
      </div>
      {bottom && <div className='tw-text-gray-dark'>{bottom}</div>}

      {breakdown.length > 0 && (
        <ul
          className={classNames('tw-overflow-x-hidden tw-pl-5 tw-transition-all tw-duration-200', {
            'tw-max-h-96': breakdownExpanded,
            'tw-max-h-0': !breakdownExpanded,
          })}>
          {breakdown.map((item) => (
            <li
              key={`${item.text}-${getRandomNumber()}`}
              className='tw-flex tw-items-center tw-justify-between tw-font-normal'>
              <span>{item.text}</span> <span>{formatCurrency(item.value * quantity)}</span>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default memo(ItemPricing);
